import {formatter, request} from '@/utils/request';

export namespace Company {
  export const Path = {
    Search: '/expenseapi/company/search',
    Get: '/expenseapi/company/get',
    SearchForSp: '/expenseapi/company/searchForSp',
  };


  export async function search(body: API.CompanyFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Company[]>>(Path.Search, formatter(options));
  }

  export async function get(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.Company>>(Path.Get, formatter(options));
  }

  export async function searchForSp(body: { formSaId?: number; paymentMethodId?: number; soldToCode?: string }) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Company[]>>(Path.SearchForSp, formatter(options));
  }
}
